import Vue from 'vue'
import Router from 'vue-router'
import CheckAuth from './router/middleware/checkAuth'
import store from './store/store'

Vue.use(Router)

const routes = [
  {
// =============================================================================
// MAIN LAYOUT ROUTES
// =============================================================================
    path: '',
    component: () => import('./layouts/main/Main.vue'),
    children: [
      {
        path: '/scraping',
        name: 'Scarping',
        component: () => import('./views/scraping'),
        meta: {
          pageTitle: 'Scarping',
          rule: 'editor',
        },
      },
      {
        path: '/',
        name: 'Home',
        component: () => import('./views/pages/sendNotification/SendNotification.vue'),
        meta: {
          pageTitle: 'Send Notification',
          rule: 'editor',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/scheduled-emails',
        name: 'Home',
        component: () => import('./views/pages/scheduledEmails/ScheduledEmails.vue'),
        meta: {
          pageTitle: 'Scheduled Emails',
          rule: 'editor',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/companies',
        name: 'Companies',
        component: () => import('./views/pages/company/All'),
        meta: {
          pageTitle: 'Companies',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/add-company',
        name: 'add-company',
        component: () => import('./views/pages/company/Add'),
        meta: {
          pageTitle: 'Add New Company',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/edit-company/:companyID',
        name: 'edit-company',
        component: () => import('./views/pages/company/Edit'),
        meta: {
          pageTitle: 'Edit Company',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/companies-groups',
        name: 'Companies Groups',
        component: () => import('./views/pages/companyGroup/All'),
        meta: {
          pageTitle: 'Companies Groups',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/add-companies-group',
        name: 'add-companies-group',
        component: () => import('./views/pages/companyGroup/Add'),
        meta: {
          pageTitle: 'Add New Group',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/edit-companies-group/:companiesGroupID',
        name: 'edit-companies-group',
        component: () => import('./views/pages/companyGroup/Edit'),
        meta: {
          pageTitle: 'Edit Companies Group',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
  
    ],
  },
// =============================================================================
// FULL PAGE LAYOUTS
// =============================================================================
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/login',
        name: 'pageLogin',
        component: () => import('@/views/pages/Login.vue'),
        meta: {
          pageTitle: 'Login',
          rule: 'editor'
        }
      },
      {
        path: '/pages/error-404',
        name: 'pageError404',
        component: () => import('@/views/pages/Error404.vue'),
        meta: {
          pageTitle: 'Error 404',
          rule: 'editor'
        }
      },
    ]
  },
  // Redirect to 404 page, if no match found
  {
    path: '*',
    redirect: '/pages/error-404'
  }
];

function middlewarePipeline (context, middleware, index) {
  const nextMiddleware = middleware[index]

  if(!nextMiddleware){
    return context.next
  }

  return () => {
    const nextPipeline = middlewarePipeline(
      context, middleware, index + 1
    )
    nextMiddleware({ ...context, next: nextPipeline })
  }
}

const router = new Router({
  mode: 'history',
  base: '/',
  routes: routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.pageTitle + ' - Lemon Spaces'
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })

})

export default router
